import Vue from 'vue'

import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Search from '@/components/Search'
import store from '../store/store'
import Pay from '@/components/Pay'
import UserInfo from '@/components/UserInfo'
import Forgot from '@/components/Forgot'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requireLogin: false,
        title: '题库巴巴 www.tiku88.com'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requireLogin: false,
        title: '题库巴巴-登录'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        requireLogin: false,
        title: '题库巴巴-注册'
      }
    },
    {
      path: '/searchAnswer/search',
      name: 'search',
      component: Search,
      meta: {
        requireLogin: false,
        title: '题库巴巴'
      }
    },
    {
      path: '/pay',
      name: 'pay',
      component: Pay,
      meta: {
        requireLogin: true,
        title: '题库巴巴-支付'
      }
    },
    {
      path: '/user',
      name: 'user',
      component: UserInfo,
      meta: {
        requireLogin: true,
        title: '题库巴巴-个人信息'
      }
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot,
      meta: {
        requireLogin: false,
        title: '题库巴巴-找回密码'
      }
    }
  ]
})

export default router

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // eslint-disable-next-line
  if (_hmt) {
    if (to.path) {
      // eslint-disable-next-line
      _hmt.push(['_trackPageview', to.fullPath])
    }
  }

  let isLogin = store.getters.isLogin // 当前登录状态
  let requireLogin = to.meta.requireLogin // 对应页面是否需要登录
  if (requireLogin === true && isLogin === false) {
    router.push({path: '/login'})
    return false
  }
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js